export const apiUrl = process.env.API_URL;
export const version = process.env.VERSION;
export const userTokenStorageKey = "APP_USER_TOKEN";
export const bridgeAngularJS = false;
export const authDisabled = false;
export const permanent = false;
export const DefaultPermissions = {};